let resumeData = {
  "imagebaseurl": "https://github.com/kevinyc-dri/2ndPortfolio.git",
  "name": "Kevin",
  "role": "Software Engineer",
  "roleDescription": " I build frontend and backend applications. I have a passion for building and teaching code. On my free time, I skateboard with my son and chill at the beach!",
}
export default resumeData